import ComplexTranslate from 'components/ComplexTranslate';
import { TWO_FACTOR_AUTH_TYPES } from 'components/common/constants';

/**
 * TRN-7254 — the "where did this code come from" line shown under the modal's title. Shared by
 * every ConfirmationModal consumer that does code-entry-or-status for more than one confirmation
 * type: login/password-recovery's Sms.js and payments/cards/etc.'s
 * PopUpInternalActionConfirmationScheme.
 *
 * @param { string } type - a TWO_FACTOR_AUTH_TYPES value
 * @param { string } destinationText - phone number / masked email, plain text (this wraps it in
 *   <strong> itself). Can be falsy — e.g. at login, switching the confirmation method to EMAIL
 *   after logging in via the Phone tab means no email address was ever collected — in which case
 *   a generic, destination-less sentence is used instead of leaving the placeholder empty.
 * @param i18n
 */
export const getConfirmationSubtitle = (type, destinationText, i18n) => {
  const destination = destinationText ? <strong>{destinationText}</strong> : null;

  switch (type) {
    case TWO_FACTOR_AUTH_TYPES.WHATSAPP:
      return destination ? (
        <ComplexTranslate text={'sms.header.subtitle.whatsapp'} interpolation={{ phone: destination }} />
      ) : (
        i18n.getMessage('sms.header.subtitle.whatsapp.generic')
      );
    case TWO_FACTOR_AUTH_TYPES.GOOGLE_AUTH:
      return i18n.getMessage('2fa.auth.description');
    case TWO_FACTOR_AUTH_TYPES.PUSH_NOTIFICATION:
      return i18n.getMessage('sms.description.pushNotification');
    case TWO_FACTOR_AUTH_TYPES.EMAIL:
      return destination ? (
        <ComplexTranslate text={'sms.header.subtitle'} interpolation={{ phone: destination }} />
      ) : (
        i18n.getMessage('sms.header.subtitle.email.generic')
      );
    case TWO_FACTOR_AUTH_TYPES.SMS:
    default:
      return destination ? (
        <ComplexTranslate text={'sms.header.subtitle'} interpolation={{ phone: destination }} />
      ) : (
        i18n.getMessage('sms.header.subtitle.generic')
      );
  }
};
